import React from 'react';
import StreamLogTable from './ui/StreamLogTable';
import { useHttpEventStream, clearHttpEventStreamLog } from '../utils/httpEventStreams';
import './streamBuilders.css';

const STATUS_LABEL = { pending: 'Connecting…', streaming: 'Streaming', ended: 'Stream ended', stopped: 'Stopped', error: 'Stream broke' };
const STATE_CLASS = { streaming: 'connected', pending: 'connecting', error: 'error' };

/**
 * "Streaming" — beside the HTTP status the response bar already shows (`200 OK · Streaming`).
 * The response has ONE status row; the stream adds its state to it, not a header of its own
 * (owner, 20.09.2026: two "200 OK" made no sense).
 */
export function HttpEventStreamState({ tabId }) {
  const { status } = useHttpEventStream(tabId);
  if (status === 'idle') return null;
  return (
    <span className={`stream-bar__state stream-bar__state--${STATE_CLASS[status] || 'disconnected'}`} role="status">
      <span className="stream-bar__dot" aria-hidden />
      {STATUS_LABEL[status] || 'Stream ended'}
    </span>
  );
}

/**
 * The BODY of an HTTP response that is an event stream (`content-type: text/event-stream`):
 * the events as they arrive — the log table the SSE and WebSocket builders use. No header of
 * its own: status, time and the Headers / Cookies tabs are the response bar's, as for every
 * other response. The rows live in `utils/httpEventStreams.js`, per tab.
 */
export default function HttpEventStreamView({ tabId }) {
  const { status, entries, dropped } = useHttpEventStream(tabId);
  return (
    <div className="flex h-full flex-col overflow-hidden" style={{ minHeight: 0 }}>
      <StreamLogTable
        key={tabId}
        entries={entries}
        dropped={dropped}
        filters={['all', 'received', 'events']}
        onClear={() => clearHttpEventStreamLog(tabId)}
        emptyText={status === 'streaming' ? 'Waiting for events…' : 'No events.'}
      />
    </div>
  );
}
